<style lang="stylus" scoped>
    .image-model-container
        width: 480px
        .dialog-slot{
          padding-top: 10px
        }
        .image-model-tab
            display flex
            div+div{
              margin-left: 24px
            }
            div
                font-size 13px
                padding 2px 0px
                cursor pointer
            .image-tab-active
                color var(--themeColor)
                font-weight: 700;
                border-bottom 2px solid var(--themeColor)
        .image-local
            font-size: 16px
            background-color: var(--bg-color-insert-image-modal)
            margin-top: 20px
            border 2px dashed $box-bordercolor
            height 250px
            width 100%
            display flex
            justify-content center
            align-content center
            flex-wrap wrap
            border-radius: $box-radius;
            &:hover
                border-color var(--themeHover);
            .image-local-tip
                color var(--text-color-tertiary)
                margin-top: 20px
                width 100%
                text-align center
                line-height 2
                pointer-events none
            .image-local-btn
                background var(--themeColor)
                color #fff;
                height: 36px
                line-height: 36px;
                display: flex;
                align-items: center;
                padding 6px 12px
                border-radius 6px
                cursor pointer
                font-size: 12px
                &:hover
                    background-color: var(--themeHover);
                svg{
                  width: 32px
                  margin-right: 8px
                }
        .image-url
            margin-top: 20px
            .image-url-inp
                display flex
                justify-content space-between
                align-items center
                height 30px
                input
                    flex 1
                    border 1px solid $box-bordercolor
                    height 100%
                    outline none
                    padding-left 6px
                    border-radius: 6px;
                    background-color var(--bg-color-tertiary)
                    &::placeholder{
                      font-size: 12px;
                      color: var(--text-color-tertiary);
                    }
                    &:focus{
                      border: 1px solid var(--themeColor);
                      box-shadow: 0px 0px 0px 2px var(--theme-color-10);
                    }
                div
                    background-color: var(--themeColor)
                    color #fff;
                    padding 0px 20px
                    line-height 30px
                    border-radius $box-radius
                    cursor pointer
                    margin-left 12px
                    height 100%
                    &:hover{
                      background-color: var(--themeHover);
                    }
            .image-url-tip
                padding 12px 0;
                color var(--text-color-tertiary);
</style>

<template>
    <Dialog :title="$t('title')" :isShow="true" :mask="true" class="image-model-container" @close="close">
        <div class="image-model-tab">
            <div :class="{ 'image-tab-active': activeTab == 1 }" @click="setTab(1)">{{ $t("upload") }}</div>
            <div :class="{ 'image-tab-active': activeTab == 2 }" @click="setTab(2)">{{ $t("online") }}</div>
        </div>
        <div
            class="image-local"
            v-show="activeTab == 1"
            @dragenter="fileDragenter($event)"
            @dragleave="fileDragleave($event)"
            @dragover="fileDragOver($event)"
            @drop="fileDrop($event)"
        >
            <label class="image-local-btn dialog-btn-ok" for="choosePicture">
                <iconSymbol name="import-image" />
                {{ $t("selectLocalImage") }}
            </label>
            <input style="display: none" id="choosePicture" multiple accept=".bmp, .png, .jpg, .jpeg, .ico, .svg" type="file" @change="addPicture" />
            <div class="image-local-tip">
                {{ $t("dragImage") }}
            </div>
        </div>
        <div class="image-url" v-show="activeTab == 2">
            <div class="image-url-inp">
                <input type="text" :placeholder="$t('urlPlaceholder')" v-model="src" @keydown.enter="insetImage()" />
                <div class="dialog-btn-ok" @click="insetImage()">{{ $t("insertImage") }}</div>
            </div>
            <div class="image-url-tip">{{ $t("tips") }}</div>
        </div>
    </Dialog>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            Dialog,
        },
    })
    export default class Base extends Vue {
        @Inject()
        ["showMessage"];

        top = 0;
        left = 0;
        activeTab = 1;
        src = "";
        //生命周期
        mounted() {}

        created() {}

        setTab(tab) {
            this.activeTab = tab;
        }

        close() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }

        addPicture(e: MouseEvent) {
            let view = window["_view"];
            if (!(<HTMLInputElement>e.srcElement).files.length || !view) return;
            view.insertImageFromFile((<HTMLInputElement>e.srcElement).files);
            this.close();
        }

        fileDragenter(e) {
            (<HTMLInputElement>document.querySelector(".image-local")).style.backgroundColor = "#eeeeee";
        }
        fileDragleave(e) {
            (<HTMLInputElement>document.querySelector(".image-local")).style.backgroundColor = "#fff";
        }
        // 禁止浏览器默认事件
        fileDragOver(e) {
            e.preventDefault();
        }
        // 拖拽上传图片
        fileDrop(e) {
            e.stopPropagation();
            e.preventDefault();
            let files = e.dataTransfer.files;
            e.target.style.backgroundColor = "transparent";
            if (files.length > 0) {
                let view = window["_view"];
                if (!view) return;
                view.insertImageFromFile(files);
                this.close();
            }
        }

        insetImage(src = "") {
            let url = src || this.src;
            let msg1 = this.$t("insertFail");
            let msg2 = this.$t("inputURL");
            if (url) {
                let params = { url };
                this.$edApi
                    .getInternetImage(params)
                    .then((res) => {
                        let view = window["_view"];
                        // url 可能是 base64, 也可能没有包含suffix 信息
                        let suffix = "";
                        if (url.startsWith("data:image/")) {
                            let pos = url.indexOf(";");
                            if (pos !== -1) {
                                suffix = url.substring(11, pos);
                            } else {
                                suffix = url.substr(11, 3);
                            }
                        } else {
                            suffix = ".png"; //url.split('.').pop();
                        }
                        view.insertImageFromOL(res, suffix);
                        this.close();
                    })
                    .catch((err) => {
                        this.showMessage({
                            type: 2,
                            imgType: 2,
                            content: msg1,
                        });
                    });
            } else {
                this.showMessage({
                    type: 2,
                    content: msg2,
                });
            }
        }
    }
</script>
<i18n>
{
  "zh": {
    "title": "插入图片",
    "upload": "本地上传",
    "online": "在线图片",
    "search": "搜索图片",
    "dragImage": "将您的图片拖动到此处",
    "or": "或",
    "selectLocalImage": "选择本地图片",
    "insertImage": "插入图片",
    "tips": "如果图片源站点禁止对图片的引用会导致图片加载失败，此时可先保存到本地再使用。",
    "urlPlaceholder": "请将图片地址粘贴到此处。(Crtl + V)",
    "searchPlaceholder": "请输入搜索关键字",
    "insertFail": "插入图片失败, 请先保存图片到本地再使用",
    "inputURL": "请输入图片地址"
  },
  "en": {
    "title": "Insert Image",
    "upload": "Upload File",
    "online": "Online Image",
    "search": "Search Image",
    "dragImage": "Drag Your Image Here",
    "or": "Or",
    "selectLocalImage": "Select Local Image",
    "insertImage": "Insert Image",
    "tips": "If the image is protected from citing by its source site, the image will fail to load. In this case, you can save image to local disk first.",
    "urlPlaceholder": "Please paste image URL here.(Crtl + V)",
    "searchPlaceholder": "Please enter search keyword.",
    "insertFail": "Failed to insert image, please save image to local disk first.",
    "inputURL": "Please enter image URL."
  },
  "jp": {
    "title": "画像を挿入",
    "upload": "ローカル画像",
    "online": "オンライン画像",
    "search": "画像を検索",
    "dragImage": "画像をここにドラッグ",
    "or": "または",
    "selectLocalImage": "ローカル画像を選択",
    "insertImage": "画像を挿入",
    "tips": "画像がソースサイトによる引用から保護されている場合、画像のアップロードは失敗になります。この場合に、画像をまずローカルディスクに保存してください。",
    "urlPlaceholder": "画像のURLをここに貼り付けてください",
    "searchPlaceholder": "検索キーワードを入力してください",
    "insertFail": "画像の挿入に失敗しました。画像をまずローカルディスクに保存してください",
    "inputURL": "画像のURLを入力してください"
  },
  "fr": {
    "title": "Insérer Image",
    "upload": "Téléverser Fichier",
    "online": "Image en Ligne",
    "search": "Recherche d'image",
    "dragImage": "Faites Glisser votre Image Ici",
    "or": "Ou",
    "selectLocalImage": "Sélectionner Image Locale",
    "insertImage": "Insérer Image",
    "tips": "Si le site source d'images interdit les références aux images,  l'image ne parviendra pas à la charge.Dans ce cas, vous pouvez l'enregistrer sur votre ordinateur local avant de l'utiliser.",
    "urlPlaceholder": "Veuillez coller l'URL de l'image ici. (Ctrl + V)",
    "searchPlaceholder": "Veuillez entrer un mot-clé de recherche.",
    "insertFail": "Échec de l'insertion de l'image, veuillez enregistrer l'image au local avant de l'utiliser",
    "inputURL": "Veuillez entrer l'URL de l'image."
  },
  "de": {
    "title": "Bild eingeben",
    "upload": "Datei hochladen",
    "online": "Online Bild",
    "search": "Bildsuchen",
    "dragImage": "Bild hier hineinziehen",
    "or": "Oder",
    "selectLocalImage": "Lokales Bild auswählen",
    "insertImage": "Bild einfügen",
    "tips": "Wenn das Image durch seine Quellwebsite vor dem Zitieren geschützt ist, kann das Bild nicht geladen werden. In diesem Fall sollten Sie das Bild zuerst auf der lokalen Festplatte speichern.",
    "urlPlaceholder": "Bitte fügen Sie hier die Bild-URL ein. (Strg + V)",
    "searchPlaceholder": "Bitte geben Sie das Suchwort ein.",
    "insertFail": "Bild konnte nicht eingefügt werden. Bitte speichern Sie das Bild zuerst auf der lokalen Festplatte.",
    "inputURL": "Bitte geben Sie die Bild-URL ein."
  },
  "es": {
    "title": "Insertar imagen",
    "upload": "Subir archivo",
    "online": "Imagen en línea",
    "search": "Imagen de búsqueda",
    "dragImage": "Arrastre su imagen aquí",
    "or": "O",
    "selectLocalImage": "Selecciona imagen local",
    "insertImage": "Insertar Imagen",
    "tips": "Si la imagen está protegida de ser citada por su sitio de origen, la imagen no se cargará. En este caso, puede guardar la imagen en el disco local primero",
    "urlPlaceholder": "Por favor, introduzca la palabra clave de búsqueda(Crtl + V)",
    "searchPlaceholder": "Por favor, introduzca la palabra clave de búsqueda",
    "insertFail": "Fallido al insertar la imagen, por favor, guarde la imagen en el disco local primero",
    "inputURL": "Por favor, introduzca la URL de la imagen"
  },
  "pt": {
    "title": "Inserir Imagem",
    "upload": "Carregar Ficheiro",
    "online": "Imagem Online",
    "search": "Pesquisar Imagem",
    "dragImage": "Arrastar a Imagem Aqui",
    "or": "Ou",
    "selectLocalImage": "Selecionar Imagem Local",
    "insertImage": "Inserir Imagem",
    "tips": "Se a imagem está protegida de citações pelo seu site de fonte, a imagem irá falhar ao carregar. Neste caso, pode gravar a imagem no disco local primeiro.",
    "urlPlaceholder": "Por favor, colar URL da imagem aqui.(Crtl + V)",
    "searchPlaceholder": "Por favor, inserir pesquisa por palavra-chave.",
    "insertFail": "Falha ao inserir imagem, por favor, gravar a imagem no disco local primeiro.",
    "inputURL": "Por favor, inserir URL da imagem."
  },
  "it": {
    "title": "Inserisci Immagine",
    "upload": "Carica File",
    "online": "Immagine Online",
    "search": "Ricerca Immagine",
    "dragImage": "Trascina Qui la Tua Immagine",
    "or": "O",
    "selectLocalImage": "Seleziona un'Immagine Locale",
    "insertImage": "Inserisci Immagine",
    "tips": "Le immagini protette dalla citazione dal sito di origine non possono essere caricate. Si prega di salvare l'immagine sul computer e caricarla dalle cartelle locali.",
    "urlPlaceholder": "Si prega di copiare la URL dell'immagine (Ctrl + V)",
    "searchPlaceholder": "Si prega di digitare la parola chiave da cercare.",
    "insertFail": "Impossibile inserire l'immagine. Si prega di salvarla sul computer e riprovare.",
    "inputURL": "Si prega di immettere l'URL dell'immagine."
  },
  "tw": {
    "title": "插入圖片",
    "upload": "本地上傳",
    "online": "在線圖片",
    "search": "搜尋圖片",
    "dragImage": "將您的圖片拖動到此處",
    "or": "或",
    "selectLocalImage": "選擇本地圖片",
    "insertImage": "插入圖片",
    "tips": "如果圖片源站點禁止對圖片的引用會導致圖片加載失敗，此時可以先儲存到本地再使用",
    "urlPlaceholder": "請將圖片地址貼上到此處。(Crtl + V)",
    "searchPlaceholder": "請輸入搜尋關鍵字",
    "insertFail": "插入圖片失敗, 請先儲存圖片到本地再使用",
    "inputURL": "請輸入圖片地址"
  },
  "kr": {
    "title": "이미지 삽입",
    "upload": "파일 업로드",
    "online": "온라인 이미지",
    "search": "이미지 검색",
    "dragImage": "이미지를 여기로 끌어다 놓기",
    "or": "또는",
    "selectLocalImage": "로컬 이미지 선택",
    "insertImage": "이미지 삽입",
    "tips": "원본 사이트에서 이미지를 인용하지 못하도록 보호하면 이미지가 로드되지 않습니다. 이 경우 먼저 이미지를 로컬 디스크에 저장한 다음 사용하십시오.",
    "urlPlaceholder": "이미지 URL을 여기에 붙여 넣으십시오.(Crtl + V)",
    "searchPlaceholder": "검색 키워드를 입력하십시오.",
    "insertFail": "이미지를 삽입하지 못했습니다. 이미지를 먼저 로컬 디스크에 저장하십시오.",
    "inputURL": "이미지 URL을 입력하십시오."
  }
}
</i18n>
